import { ReactElement } from 'react';

import { Patient as WaitlistPatient } from '@dreryk/egabinet-waitlist-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { BindingCreator } from '@dreryk/react-common';

import { usePatientSimpleSearchCreator } from '~libs.desktop.shared.patient';

import { translationKeys } from '../../../translations';

import { patientItemRenderer, patientLabelExtractor } from './PatientField.utils';
import { StyledPatientField } from './PatientField.styled';

type PatientFormBeanPart = {
   patient: WaitlistPatient | PatientSimple | null;
};

type PatientFieldProps = {
   register: BindingCreator<PatientFormBeanPart>;
};

export const PatientField = (props: PatientFieldProps): ReactElement => {
   return (
      <StyledPatientField<WaitlistPatient | PatientSimple>
         searchCreator={usePatientSimpleSearchCreator}
         noResultsMessage={translationKeys.patientNotFound}
         label={translationKeys.patient}
         keyProperty={'id'}
         itemRenderer={patientItemRenderer}
         labelExtractor={patientLabelExtractor}
         controller={props.register('patient', {
            required: true,
         })}
         placeholder={translationKeys.enterNameIdOrPhoneNumber}
         minChars={3}
         testId={'patient'}
      />
   );
};
